module.exports = __webpack_public_path__ + "static/media/bg53.d5a92dbb.png";